import React from 'react';
import { Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareFull } from '@fortawesome/pro-solid-svg-icons';
import { Chart } from 'react-google-charts';

class SentimentBreakdown extends React.PureComponent {
  constructor(props) {
    super(props);
    const { scores } = props;

    this.state = {
      positive: Math.round(scores.Positive * 100),
      neutral: Math.round(scores.Neutral * 100),
      negative: Math.round(scores.Negative * 100),
      mixed: Math.round(scores.Mixed * 100),
    };
  }

  render() {
    const {
      positive,
      neutral,
      negative,
      mixed,
    } = this.state;

    return (
      <div className="d-flex align-items-center">
        <Chart
          width="100%"
          height="18rem"
          chartType="PieChart"
          loader={(
            <div>
              <Spinner type="grow" className="me-3" />
              Loading Chart
            </div>
          )}
          data={[
            ['Sentiment', 'Rating'],
            ['Positive', positive],
            ['Neutral', neutral],
            ['Negative', negative],
            ['Mixed', mixed],
          ]}
          options={{
            legend: {
              position: 'none',
            },
            tooltip: {
              showColorCode: true,
              trigger: 'selection',
              text: 'percentage',
            },
            animation: {
              duration: 1000,
              easing: 'out',
              startup: true,
            },
            colors: ['#28a745', '#f3c51f', '#E57373', '#89AAFD'],
          }}
        />
        <div className="text-nowrap pe-3 mt-n5 text-left">
          <div>
            <FontAwesomeIcon
              fixedWidth
              icon={faSquareFull}
              className="me-1 text-success"
              size="xs"
            />
            {'Positive: '}
            <strong>{`${positive}%`}</strong>
          </div>
          <div>
            <FontAwesomeIcon
              fixedWidth
              icon={faSquareFull}
              className="me-1 text-warning"
              size="xs"
            />
            {'Neutral: '}
            <strong>{`${neutral}%`}</strong>
          </div>
          <div>
            <FontAwesomeIcon
              fixedWidth
              icon={faSquareFull}
              className="me-1 text-danger"
              size="xs"
            />
            {'Negative: '}
            <strong>{`${negative}%`}</strong>
          </div>
          <div>
            <FontAwesomeIcon
              fixedWidth
              icon={faSquareFull}
              className="me-1 text-info"
              size="xs"
            />
            {'Mixed: '}
            <strong>{`${mixed}%`}</strong>
          </div>
        </div>
      </div>
    );
  }
}

export default SentimentBreakdown;
